import { useParams } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { StripeSettings } from "../components/StripeSettings";

export function StripePage() {
  const { user } = useAuth();
  const { business, businessId, loading } = useCurrentBusiness();
  const { locationId } = useParams();
  return (
    <Page>
      <PageHeader title="Stripe" />
      <PageContent>
        {loading ? (
          <LoadingSpinner message="Loading business..." />
        ) : business && businessId && locationId && user && business.ownerId === user.id ? (
          <StripeSettings
            key={`${businessId}:${locationId}:${user.id}`}
            businessId={businessId}
            businessName={business.name}
            locationId={locationId}
            userId={user.id}
          />
        ) : (
          <ErrorState message={business ? "Only the business owner can manage Stripe." : "Select a business to manage Stripe."} />
        )}
      </PageContent>
    </Page>
  );
}
